module.exports = {"id":"dp2_3l1q4","text":"Engaging in Citizenship through Digital Technologies","instructions":"Are there laws that protect users of digital platforms?","groupTitle":"Digital Profiler Knowledge Matrix","multiselect":false,"questionType":"PickOne","random":false,"options":[{"id":"dp2_3l1q4-a1","text":"Yes, there are user protection laws","score":1.8},{"id":"dp2_3l1q4-a2","text":"No, platforms set all rules","score":0},{"id":"dp2_3l1q4-a3","text":"Not sure","score":0}],"category":"2.3"}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat2.3/l1q4.json
// module id = 1031
// module chunks = 41